import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { BaseDropDown } from '../operations/common/dropdowns';
import { TRootState } from '../../reducers';
import { TServiceKey } from '../../types';

type TSelectRoleProps = {
    onFilterChange: () => void;
    currentUrlParams: any;
};

function SelectRoleRaw({ onFilterChange, currentUrlParams }: TSelectRoleProps) {
    const [defaultServiceSelection, setDefaultServiceSelection] = useState(null);
    const [services, setServices] = useState(null);
    const {
        servicesStructure,
        user,
    } = useSelector((state: TRootState) => ({
        servicesStructure: state.servicesStructure,
        user: state.user,
    }));

    useEffect(() => {
        const servicesList =
            servicesStructure &&
            Object.entries(servicesStructure)
                .filter(([, serviceData]) => user.isAgent || serviceData.client_enabled !== false)
                .map(([serviceKey, serviceData]) => ({
                label: serviceData.label,
                value: serviceKey,
            }));

        setServices(servicesList);
        setDefaultServiceSelection(
            servicesList?.find(service => service.value === ''),
        );
    }, [servicesStructure]);

    const selectedService: TServiceKey = currentUrlParams.get('service');
    const serviceParams = servicesStructure && servicesStructure[selectedService];
    const roleKey = serviceParams && serviceParams.role_filter_name;
    const rolesRaw = serviceParams && serviceParams[roleKey];
    const defaultRoleLabel = roleKey && rolesRaw[''].label;
    const selectedRole = currentUrlParams.get(roleKey);
    const isRoleNotSelected = currentUrlParams.get(roleKey) !== '';
    const defaultRoleSelection = isRoleNotSelected &&
        defaultRoleLabel && {
            label: defaultRoleLabel,
            value: '',
        };

    type TRole = [
        string,
        {
            label: string;
        },
    ];

    const rolesList =
        roleKey &&
        Object.entries(rolesRaw)
            .filter(([, roleData]: [string, any]) => user.isAgent || roleData.client_enabled !== false)
            .map((role: TRole) => ({
                label: (
                    role.find((elem: string | { label: string }) =>
                        elem.hasOwnProperty('label'),
                    ) as { label: string }
                ).label,
                value: role.find(
                    (elem: string | { label: string }) =>
                        !elem.hasOwnProperty('label'),
                ),
            }));

    return (
        <>
            {services && (
                <BaseDropDown
                    filterKey="service"
                    selected={selectedService}
                    options={services}
                    defaultSelection={defaultServiceSelection}
                    onFilterChange={onFilterChange}
                />
            )}
            {selectedService && rolesList && (
                <BaseDropDown
                    filterKey={roleKey}
                    selected={selectedRole}
                    options={rolesList}
                    defaultSelection={defaultRoleSelection}
                    onFilterChange={onFilterChange}
                />
            )}
        </>
    );
}

export const SelectRole = React.memo(SelectRoleRaw);
